var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum3BlueBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1885,
    cy: 16.9863,
    r: 15.5,
    stroke: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.882 23.1963C14.127 23.1963 12.942 22.5363 12.162 21.6513L13.197 20.2563C13.857 20.9013 14.667 21.3963 15.672 21.3963C16.797 21.3963 17.562 20.8413 17.562 19.8363C17.562 18.7563 16.917 18.0663 14.502 18.0663V16.4913C16.542 16.4913 17.202 15.7863 17.202 14.7963C17.202 13.9263 16.662 13.4163 15.717 13.4163C14.922 13.4163 14.277 13.7763 13.617 14.3913L12.492 13.0413C13.452 12.2013 14.517 11.6763 15.822 11.6763C17.967 11.6763 19.422 12.7413 19.422 14.6313C19.422 15.8313 18.747 16.7013 17.577 17.1663V17.2413C18.822 17.5863 19.782 18.5163 19.782 19.9713C19.782 22.0113 17.997 23.1963 15.882 23.1963Z",
    fill: "#1167ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum3BlueBorder);
export default __webpack_public_path__ + "static/media/icon_circleNum_3_blueBorder.f2983e37eaa2d3b0ef9baaead25cf2b3.svg";
export { ForwardRef as ReactComponent };